import { render, staticRenderFns } from "./Twitch.vue?vue&type=template&id=7825447a&"
import script from "./Twitch.vue?vue&type=script&lang=ts&"
export * from "./Twitch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports